// Vendors
import React from 'react'
import { useParams } from 'react-router'

// Components
import { CompanyClinicFormShow } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

import { PageMetaSetting } from './meta'

export const PageCompanyClinicShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <LayoutLoggedPageList title={title}>
      <CompanyClinicFormShow endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
